
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketing-communication-terms",
      function () {
        return require("private-next-pages/marketing-communication-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketing-communication-terms"])
      });
    }
  